// @flow

import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Row, Col, Input } from 'reactstrap';

type Props = {
  onChange: (query: string) => void,
  value: string,
};

@observer
export default class SearchBar extends React.Component<Props, void> {
  
  @observable value: string = '';
  
  handleChange = ({ target: { value } }: any) => {
    this.props.onChange(value);
  };
  
  render() {
    const { props: { value } } = this;
    return (
      <Row>
        <Col>
          <Input value={value} onChange={this.handleChange} placeholder="Zum Suchen tippen..."/>
        </Col>
      </Row>
    )
  }
}


// WEBPACK FOOTER //
// ./src/App/Components/Layout/SearchBar/index.js